import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const DivinationSvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 60 60">
      <path
        fill={fillColor}
        d="M50.1 29.3c.2-.7 1.3-.9 1.7-.3 1 1.2.8 3.2 0 4.7-2 3.7-6.5 4.8-10 6.8-3.3 1.8-6.7 4-9 7q-.5.4-.7 1l-.1.3c-.5 1.1-2 1.5-3 .9q-.5-.3-.7-.8l-.1-.4-.3-.5c-2.3-3.3-6-5.4-9.6-7.4s-7.9-3.1-10.1-6.8c-1-1.5-1-3.6.3-4.8a1 1 0 0 1 1.6.4l1 2.6c2.2 2.8 6 3.5 9 5.2 2.8 1.6 7.5 4.3 10 7.5l.4-.4a36 36 0 0 1 9.7-7c3-1.7 6.8-2.4 9-5.1.7-1 .5-1.7 1-2.9M28.4 9.6c.7-1.3 2.7-1.3 3.3 0q1.5 2.6 3.3 5.1c.9 1 1.8 2.3 2.9 2.8h.1l3.7-1.3c1.3-.5 2.7 1 2.1 2.3-1.4 3.6-3 7.6-4.5 11q-.7 2-2 3.6c-.6.5-1.7.1-1.7-.7-.1-1.4.5-2.6.9-3.9l1.3-3.8q.7-1.7 1.4-4-.7.4-1.5.3c-3-.3-5.6-3.8-7.6-6.9-2.2 3.5-5.5 8-9 6.9l2.8 7.4c.5 1.2 1 2.5.6 4-.1.7-1 1-1.5.6a7 7 0 0 1-2.3-3.3L19.2 26l-3-7.4c-.6-1.5 1-3 2.4-2.5l3.6 1.2h.1q.4 0 1-.6c2-1.9 3.7-4.6 5.1-7"
      />
    </BaseSvg>
  );
};

export default DivinationSvg;
